document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.book-expand__video').forEach(function (wrap) {
    wrap.addEventListener('click', function loadVideo() {
      if (wrap.querySelector('iframe')) return;

      var url = wrap.getAttribute('data-youtube-url');
      var videoId = extractYouTubeId(url);
      if (!videoId) return;

      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'lazy');

      wrap.innerHTML = '';
      wrap.appendChild(iframe);
      wrap.removeEventListener('click', loadVideo);
    });
  });

  function extractYouTubeId(url) {
    if (!url) return null;
    var match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    return match ? match[1] : null;
  }
});
// ============================================
// Additional Images — Main + Thumbnail + Arrows
// (5 thumbnails per view, main image arrows/swipe, auto-sync)
// ============================================

document.addEventListener('DOMContentLoaded', function () {
  var THUMBS_PER_VIEW = 5;

  document.querySelectorAll('.cb-gallery').forEach(function (gallery) {
    var mainImg = gallery.querySelector('.cb-gallery__main-img');
    var mainWrap = gallery.querySelector('.cb-gallery__main');
    var prevMainBtn = gallery.querySelector('.cb-gallery__main-arrow--prev');
    var nextMainBtn = gallery.querySelector('.cb-gallery__main-arrow--next');
    var thumbStrip = gallery.querySelector('.cb-gallery__thumbs');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.cb-gallery__thumb'));
    var thumbPrevBtn = gallery.querySelector('.cb-gallery__thumb-page-arrow--prev');
    var thumbNextBtn = gallery.querySelector('.cb-gallery__thumb-page-arrow--next');

    if (!mainImg || thumbs.length === 0) return;

    var images = thumbs.map(function (t) { return t.getAttribute('data-full'); });
    var currentIndex = 0;

    function scrollThumbToIndex(index) {
      if (!thumbStrip) return;
      var page = Math.floor(index / THUMBS_PER_VIEW);
      var pageWidth = thumbStrip.clientWidth;
      thumbStrip.scrollTo({ left: page * pageWidth, behavior: 'smooth' });
    }

    function updateThumbPageArrows() {
      if (!thumbStrip || !thumbPrevBtn || !thumbNextBtn) return;
      var max = thumbStrip.scrollWidth - thumbStrip.clientWidth;
      thumbPrevBtn.disabled = thumbStrip.scrollLeft <= 10;
      thumbNextBtn.disabled = thumbStrip.scrollLeft >= max - 10;
      if (max <= 10) {
        thumbPrevBtn.style.display = 'none';
        thumbNextBtn.style.display = 'none';
      }
    }

    function setMainImage(index, opts) {
      opts = opts || {};
      if (index < 0) index = 0;
      if (index > images.length - 1) index = images.length - 1;
      currentIndex = index;

      var src = images[currentIndex];
      if (src && mainImg) {
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = src;
          mainImg.style.opacity = '1';
        }, 120);
      }

      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumbs[currentIndex].classList.add('is-active');

      if (prevMainBtn) prevMainBtn.disabled = currentIndex === 0;
      if (nextMainBtn) nextMainBtn.disabled = currentIndex === images.length - 1;

      if (!opts.skipThumbScroll) scrollThumbToIndex(currentIndex);
    }
// preload all full-size images for instant switching
    images.forEach(function (src) {
      if (src) { var p = new Image(); p.src = src; }
    });
    
    // init
    setMainImage(0, { skipThumbScroll: true });
    updateThumbPageArrows();

    // thumbnail click -> jump main image
    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () {
        setMainImage(idx);
      });
    });

    // main image prev/next arrows
    if (prevMainBtn) {
      prevMainBtn.addEventListener('click', function () { setMainImage(currentIndex - 1); });
    }
    if (nextMainBtn) {
      nextMainBtn.addEventListener('click', function () { setMainImage(currentIndex + 1); });
    }

    // swipe support on main image (mobile)
    if (mainWrap) {
      var touchStartX = 0;
      var touchEndX = 0;

      mainWrap.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      mainWrap.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var delta = touchEndX - touchStartX;
        if (Math.abs(delta) < 40) return;
        if (delta < 0) {
          setMainImage(currentIndex + 1); // swipe left -> next
        } else {
          setMainImage(currentIndex - 1); // swipe right -> prev
        }
      }, { passive: true });
    }

    // thumbnail row page arrows (next/prev set of 5)
    if (thumbPrevBtn) {
      thumbPrevBtn.addEventListener('click', function () {
        thumbStrip.scrollBy({ left: -thumbStrip.clientWidth, behavior: 'smooth' });
      });
    }
    if (thumbNextBtn) {
      thumbNextBtn.addEventListener('click', function () {
        thumbStrip.scrollBy({ left: thumbStrip.clientWidth, behavior: 'smooth' });
      });
    }

    if (thumbStrip) {
      var thumbScrollTimeout;
      thumbStrip.addEventListener('scroll', function () {
        clearTimeout(thumbScrollTimeout);
        thumbScrollTimeout = setTimeout(updateThumbPageArrows, 60);
      });
    }

    window.addEventListener('resize', function () {
      updateThumbPageArrows();
      scrollThumbToIndex(currentIndex);
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var faqSection = document.getElementById('corporate-faq-section');
  if (!faqSection) return;

  var triggers = faqSection.querySelectorAll('.collapsible-trigger');
  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var targetId = trigger.getAttribute('aria-controls');
      var content = document.getElementById(targetId);
      if (!content) return;

      var isOpen = content.classList.contains('cb-faq-open');

      // close all others in this section (optional accordion behavior)
      faqSection.querySelectorAll('.collapsible-content').forEach(function (c) {
        c.classList.remove('cb-faq-open');
        c.style.maxHeight = null;
      });
      faqSection.querySelectorAll('.collapsible-trigger').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        content.classList.add('cb-faq-open');
        content.style.maxHeight = content.scrollHeight + 'px';
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
});

var pageFullyLoaded = false;

window.addEventListener('load', function () {
  pageFullyLoaded = true;
});

document.addEventListener('DOMContentLoaded', function () {
  var anchorLinks = document.querySelectorAll('a[href="#corporate-faq-section"], a[href="#corporate-contact-form"]');

  anchorLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var targetId = link.getAttribute('href').substring(1);
      var target = document.getElementById(targetId);
      if (!target) return;

      if (pageFullyLoaded) {
        scrollToTarget(target);
      } else {
        // Page still loading images — wait for it, then scroll
        window.addEventListener('load', function () {
          setTimeout(function () {
            scrollToTarget(target);
          }, 300);
        }, { once: true });
      }
    });
  });

  function getHeaderOffset() {
    var header = document.querySelector('.site-header, header, [data-header]');
    if (header) {
      return header.offsetHeight + 20;
    }
    return window.innerWidth < 750 ? 80 : 120;
  }

  function scrollToTarget(target) {
    var offset = getHeaderOffset();
    var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({ top: targetPosition, behavior: 'smooth' });

    // multiple correction passes as remaining images settle the layout
    [400, 900, 1500].forEach(function (delay) {
      setTimeout(function () {
        var correctedOffset = getHeaderOffset();
        var correctedPosition = target.getBoundingClientRect().top + window.pageYOffset - correctedOffset;
        if (Math.abs(correctedPosition - window.pageYOffset) > 15) {
          window.scrollTo({ top: correctedPosition, behavior: 'smooth' });
        }
      }, delay);
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var backToTopBtn = document.getElementById('back-to-top');
  if (!backToTopBtn) return;

  window.addEventListener('scroll', function () {
    if (window.pageYOffset > 400) {
      backToTopBtn.classList.add('show');
    } else {
      backToTopBtn.classList.remove('show');
    }
  });

  backToTopBtn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});

// ============================================
// YouTube lightweight facade — load iframe only on click
// ============================================
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.book-expand__single-video[data-video-id]').forEach(function (wrap) {
    var playBtn = wrap.querySelector('.cb-yt-play');
    if (!playBtn) return;

    playBtn.addEventListener('click', function () {
      var videoId = wrap.getAttribute('data-video-id');
      if (!videoId) return;

      var iframeTitle = playBtn.getAttribute('aria-label') || 'YouTube video';

      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', iframeTitle);

      wrap.innerHTML = '';
      wrap.appendChild(iframe);
      iframe.focus();
    });
  });
});

// ===== Industry tabs/dropdown + Auto load on scroll =====
document.addEventListener('DOMContentLoaded', function () {
  var grid = document.querySelector('.company-books-grid');
  if (!grid) return;

  var STEP = 12; // oru thadava evlo companies varanum
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.company-card'));
  var tabs = document.querySelectorAll('.cc-tab');
  var select = document.querySelector('.cc-select');
  var moreWrap = document.querySelector('.cc-more-wrap');
  var moreBtn = document.querySelector('.cc-more');
  var countEl = document.querySelector('.cc-count');
  var filter = 'all';
  var visible = STEP;
  var observer = null;

  function render() {
    var matches = cards.filter(function (c) {
      return filter === 'all' || c.dataset.industry === filter;
    });
    cards.forEach(function (c) { c.hidden = true; });
    matches.slice(0, visible).forEach(function (c) { c.hidden = false; });

    grid.classList.toggle('cc-filtered', filter !== 'all');

    if (moreWrap) moreWrap.hidden = matches.length <= visible;
    if (countEl) countEl.textContent = 'Showing ' + Math.min(visible, matches.length) + ' of ' + matches.length;
  }

  function loadMore() {
    visible += STEP;
    render();
    // re-check after new cards are added
    if (observer && moreWrap) {
      observer.unobserve(moreWrap);
      observer.observe(moreWrap);
    }
  }

  function setFilter(value) {
    filter = value;
    visible = STEP;
    tabs.forEach(function (t) {
      t.classList.toggle('is-active', t.dataset.filter === value);
    });
    if (select) select.value = value;
    render();
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () { setFilter(tab.dataset.filter); });
  });

  if (select) {
    select.addEventListener('change', function () { setFilter(select.value); });
  }

  // Auto load when the bottom of the list comes near the screen
  if ('IntersectionObserver' in window && moreWrap) {
    if (moreBtn) moreBtn.style.display = 'none'; // button not needed
    observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !moreWrap.hidden) loadMore();
    }, { rootMargin: '500px 0px' });
    observer.observe(moreWrap);
  } else if (moreBtn) {
    // old browsers: button still works
    moreBtn.addEventListener('click', loadMore);
  }

  render();
});